<section class="vertage-banner max-w-2xl mx-auto px-[12px] md:!px-0 mt-[24px] md:!mt-8">
    <div class="bg-black rounded-2xl p-[20px] md:!px-8 md:!py-6 flex flex-column md:!flex-row md:!items-center gap-[16px] md:!gap-6">
        <p class="!m-0 flex flex-wrap items-center !gap-x-2 !gap-y-1">
            <span class="text-white text-xl">{{ texts.poweredBy }}</span>
            <img class="rounded-none !h-7 w-auto !mt-1" src="/assets/images/VertageLogo.png" alt="Vertage" width="492" height="126">
        </p>

        <a [href]="url"
           target="_blank"
           rel="noopener"
           class="md:!ml-auto self-start md:!self-center shrink-0 inline-flex items-center !gap-3 !py-3 !px-5 rounded-lg font-semibold text-base !text-white !no-underline bg-brand-color hover:opacity-90 transition-opacity duration-100">
            {{ texts.findOutMore }}
            <i class="pi pi-arrow-up-right"></i>
        </a>
    </div>
</section>
